import { render, staticRenderFns } from "./GroupDocuments.vue?vue&type=template&id=29212043&scoped=true&"
import script from "./GroupDocuments.vue?vue&type=script&lang=js&"
export * from "./GroupDocuments.vue?vue&type=script&lang=js&"
import style0 from "./GroupDocuments.vue?vue&type=style&index=0&id=29212043&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29212043",
  null
  
)

export default component.exports